@if ((customLabel | translate) !== customLabel) {
  <div class="rule_label">
    {{ customLabel | translate }}
    @if (required) {
      <span class="rule_label__required" aria-hidden="true"> *</span>
    }
  </div>
}
